import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, inject, input, output } from '@angular/core';

import { BadgeComponent } from '~/app/shared/components/elements/badge/badge.component';
import { IconComponent } from '~/app/shared/components/elements/icon/icon.component';
import { LabelComponent } from '~/app/shared/components/elements/label/label.component';
import { NewTagComponent } from '~/app/domains/onboarding/components/new-tag/new-tag.component';
import { TooltipDirective } from '~/app/shared/directives/tooltip/tooltip';
import { SidebarChildItem } from '~/app/shared/types/sidebar-item.type';

@Component({
    selector: 'eb-sidebar-menu-item',
    templateUrl: './sidebar-menu-item.component.html',
    styleUrls: ['./sidebar-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IconComponent,
        BadgeComponent,
        LabelComponent,
        NewTagComponent,
        TooltipDirective,
    ]
})
export class SidebarMenuItemComponent {
    elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

    public readonly label = input('');

    @HostBinding('class.icon')
    @Input()
    public icon?: string = undefined;

    @Input()
    public notifications?: number = 0;

    public readonly description = input<string>();

    public readonly isNew = input(false);

    @HostBinding('class.selected')
    @Input()
    public selected?: boolean = false;

    @HostBinding('class.expanded')
    @Input()
    public expanded = false;

    @HostBinding('class.disabled')
    @Input()
    public disabled?: boolean = false;

    @HostBinding('class.icon-position-start')
    public get isIconPositionStart(): boolean {
        return this.iconPosition() === 'start';
    }

    public readonly iconPosition = input<'top' | 'start'>('start');

    public readonly children = input<SidebarChildItem[]>([]);

    public readonly submenuOpen = input(false);

    public readonly activeChildKey = input<string | null>(null);

    public readonly childClick = output<SidebarChildItem>();

    public get hasChildren(): boolean {
        return this.children().length > 0;
    }

    public onChildClick(event: MouseEvent, child: SidebarChildItem): void {
        event.stopPropagation();
        if (!child.locked) {
            this.childClick.emit(child);
        }
    }
}
